import * as React from 'react';

function SvgContactMobile(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="contact_mobile_svg__prefix__contact_call"
      width={94}
      height={70}
      {...props}
    >
      <defs>
        <clipPath id="contact_mobile_svg__prefix__clip-path" />
        <filter
          id="contact_mobile_svg__prefix__Rectangle_378"
          width={112}
          height={88}
          x={-9}
          y={-9}
          filterUnits="userSpaceOnUse"
        >
          <feOffset />
          <feGaussianBlur result="blur" stdDeviation={3} />
          <feFlood floodOpacity={0.102} />
          <feComposite in2="blur" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <style>{'.contact_mobile_svg__prefix__cls-1{fill:#fff}'}</style>
      </defs>
      <g
        id="contact_mobile_svg__prefix__Mask_Group_1"
        fill="#00cd00"
        clipPath="url(#contact_mobile_svg__prefix__clip-path)"
        data-name="Mask Group 1"
        opacity={0.9}
      >
        <ellipse
          id="contact_mobile_svg__prefix__Ellipse_34"
          cx={61.25}
          cy={60.969}
          data-name="Ellipse 34"
          opacity={0.5}
          rx={61.25}
          ry={60.969}
          transform="translate(-28.5 -24.496)"
        />
        <ellipse
          id="contact_mobile_svg__prefix__Ellipse_35"
          cx={44.866}
          cy={47.786}
          data-name="Ellipse 35"
          rx={44.866}
          ry={47.786}
          transform="translate(-12.116 -11.313)"
        />
      </g>
      <g
        id="contact_mobile_svg__prefix__phone-call_2_"
        data-name="phone-call (2)"
        transform="translate(20.667 17.362)"
      >
        <g
          id="contact_mobile_svg__prefix__Group_2206"
          data-name="Group 2206"
          transform="translate(.344)"
        >
          <path
            id="contact_mobile_svg__prefix__Path_4952"
            d="M27 46.368a3.321 3.321 0 00-2.409-1.1 3.434 3.434 0 00-2.437 1.1l-2.252 2.245c-.185-.1-.371-.192-.549-.285-.257-.128-.5-.249-.705-.378a24.474 24.474 0 01-5.861-5.35 14.439 14.439 0 01-1.924-3.036c.584-.534 1.126-1.09 1.653-1.625.2-.2.4-.406.6-.606a3.269 3.269 0 000-4.931l-1.946-1.946c-.221-.221-.449-.449-.663-.677-.428-.442-.876-.9-1.34-1.325a3.373 3.373 0 00-2.387-1.048 3.491 3.491 0 00-2.423 1.048l-.014.014-2.423 2.444a5.213 5.213 0 00-1.546 3.314 12.492 12.492 0 00.912 5.287 30.682 30.682 0 005.451 9.093A33.534 33.534 0 0017.9 57.349a17.4 17.4 0 006.275 1.851c.15.007.306.014.449.014a5.37 5.37 0 004.112-1.767c.007-.014.021-.021.029-.036a16.2 16.2 0 011.247-1.29c.306-.292.62-.6.926-.919a3.555 3.555 0 001.076-2.466 3.425 3.425 0 00-1.1-2.444zm2.551 7.5c-.007 0-.007.007 0 0-.278.3-.563.57-.869.869a18.737 18.737 0 00-1.375 1.425 3.435 3.435 0 01-2.676 1.138c-.107 0-.221 0-.328-.007a15.456 15.456 0 01-5.558-1.667 31.654 31.654 0 01-10.518-8.239A28.93 28.93 0 013.1 38.843a10.175 10.175 0 01-.8-4.461 3.271 3.271 0 01.983-2.116l2.43-2.43a1.62 1.62 0 011.083-.506 1.524 1.524 0 011.04.5l.021.021c.435.406.848.827 1.283 1.276.221.228.449.456.677.691l1.945 1.945a1.36 1.36 0 010 2.209c-.207.207-.406.413-.613.613-.6.613-1.169 1.183-1.789 1.739-.014.014-.029.021-.036.036a1.453 1.453 0 00-.371 1.618l.021.064a15.618 15.618 0 002.3 3.755l.007.007a26.155 26.155 0 006.328 5.758 9.729 9.729 0 00.877.477c.257.128.5.249.705.378.029.014.057.036.086.05a1.545 1.545 0 00.705.178 1.524 1.524 0 001.083-.492l2.435-2.438a1.612 1.612 0 011.076-.534 1.451 1.451 0 011.026.52l.014.014 3.926 3.926a1.409 1.409 0 01.013 2.231z"
            className="contact_mobile_svg__prefix__cls-1"
            data-name="Path 4952"
            transform="translate(-.344 -25.453)"
          />
          <path
            id="contact_mobile_svg__prefix__Path_4953"
            d="M245.736 87.834A9.171 9.171 0 01253.2 95.3a.956.956 0 00.948.8 1.273 1.273 0 00.164-.014.963.963 0 00.791-1.112 11.089 11.089 0 00-9.036-9.036.967.967 0 00-1.112.784.952.952 0 00.781 1.112z"
            className="contact_mobile_svg__prefix__cls-1"
            data-name="Path 4953"
            transform="translate(-227.514 -79.802)"
          />
          <path
            id="contact_mobile_svg__prefix__Path_4954"
            d="M264.772 14.894A18.26 18.26 0 00249.893.015a.961.961 0 10-.314 1.9 16.31 16.31 0 0113.3 13.3.956.956 0 00.948.8 1.272 1.272 0 00.164-.014.944.944 0 00.781-1.107z"
            className="contact_mobile_svg__prefix__cls-1"
            data-name="Path 4954"
            transform="translate(-231.072)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgContactMobile;
